import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Actions from "../../../Actions";
import Form from "./Form";
import Tile from "../Layout/Tile";


class Edit extends Component{
    constructor(props){
        super(props);
        this.modalRef = false;
    }

    componentDidUpdate(){
        const { typeStore: { alert: { edit } } } = this.props;
        if(edit && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth"});
    }

    render = () => {
        const { typeStore: { alert: { edit } }, typeModal: { edit: { modal, data, data: { id = ""} } }, toggleModal, editType } = this.props;
        return (
            <div>
                <Modal size="lg" isOpen={modal} toggle={() => toggleModal("types","edit")}>
                    <ModalHeader toggle={() => toggleModal("types","edit")}>Edit Type</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>    
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {edit !== false &&
                                    <Alert color={edit.type}>
                                        {edit.message}
                                    </Alert>
                                }
                                <Form data={data} id={id} persist={editType} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    typeStore: state.typeStore,
    typeModal: state.modalStore.types,
});

const { types, modals } = Actions;

export default connect(mapStateToProps, {...types,...modals})(Edit);


// WEBPACK FOOTER //
// ./src/Components/App/Types/Edit.js